import "core-js/modules/es.array.push.js";
import PageNavBackLayoutCpt from '@/components/page/PageNavBackLayoutCpt';
import CodeDataPickerCpt from '@/components/data-picker/CodeDataPickerCpt';
import DataPickerCpt from '@/components/data-picker/DataPickerCpt';
import AddrDataPickerCpt from '@/components/data-picker/AddrDataPickerCpt';
import PopupDatePickerCpt from '@/components/date-time/PopupDatePickerCpt';
import { rqtGetBuilding } from '@/services/common/building';
import { rqtGetBank } from "@/services/common/bank";
import { rqtPostSaveallwms, rqtGetCustomer } from '@/services/cms/customer';
import { rqtGetPlace } from '@/services/common/place';
import { mapGetters } from 'vuex';
import cptCmn from '@/mixin/cpt-cmn';
import { resTol } from '@/tools/public';
export default {
  mixins: [cptCmn],
  components: {
    PageNavBackLayoutCpt,
    CodeDataPickerCpt,
    DataPickerCpt,
    AddrDataPickerCpt,
    PopupDatePickerCpt
  },
  data() {
    return {
      isClickable: true,
      isReadonly: true,
      isDisabled: false,
      btnLoading: false,
      form: {
        chnName: undefined,
        customerType: {
          text: undefined,
          value: undefined
        },
        categoryType: {
          text: undefined,
          value: undefined
        },
        obtainWay: {
          text: undefined,
          value: undefined
        },
        idType: {
          text: undefined,
          value: undefined
        },
        idNo: undefined,
        idEndDate: undefined,
        sex: {
          text: undefined,
          value: undefined
        },
        birthday: undefined,
        mobile: undefined,
        email: undefined,
        buildingId: {
          text: undefined,
          value: undefined
        },
        buildingNo: undefined,
        // 准客户
        levelType: '02',
        addrs: [],
        bankId: {
          text: undefined,
          value: undefined
        },
        bankInfo: [
          /* {
            bankId: '',//开户行
            branchBankName: '',//分行名称
            accountHolder: '',//开户名
            cardNo: '' //开户账号
          } */
        ],
        importType: {
          text: undefined,
          value: undefined
        }
      },
      fItemDataIndex: undefined,
      addrItemTpl: {
        id: undefined,
        addressType: {
          text: undefined,
          value: undefined
        },
        pcc: undefined,
        province: undefined,
        city: undefined,
        country: undefined,
        street: undefined
      },
      bankItemTpl: {
        bankId: '',
        //开户行id
        bankName: '',
        //开户行
        branchBankName: '',
        //分行名称
        accountHolder: '',
        //开户名
        cardNo: '' //开户账号
      },

      bankResItems: [{
        title: '开户行',
        dataIndex: 'bankId',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'bankId',
          title: 'bankName',
          titleAppend: 'bankCode'
        }
        // dataResCodeType: 'bankName'
      }, {
        title: '分行名称',
        dataIndex: 'branchBankName',
        dataType: 'input',
        dataRes: undefined
      }, {
        title: '开户名',
        dataIndex: 'accountHolder',
        dataType: 'input',
        dataRes: undefined
      }, {
        title: '开户账号',
        dataIndex: 'cardNo',
        dataType: 'input',
        dataRes: undefined
      }],
      codeResItems: [{
        title: '客户类型',
        dataIndex: 'customerType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerType'
      }, {
        title: '客户重要性',
        dataIndex: 'importType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerImportType'
      }, {
        title: '客户类别',
        dataIndex: 'categoryType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerCategoryType'
      }, {
        title: '获客方式',
        dataIndex: 'obtainWay',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'customerObtainWay'
      }, {
        title: '证件类型',
        dataIndex: 'idType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'idType'
      }, {
        title: '性别',
        dataIndex: 'sex',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'sex'
      }, {
        title: '地址类型',
        dataIndex: 'addressType',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        },
        dataResCodeType: 'addressType'
      }, {
        title: '居住楼盘',
        dataIndex: 'buildingId',
        dataType: 'select',
        dataRes: undefined,
        dataResItem: {
          key: 'code',
          title: 'codeName'
        }
      }],
      detail: undefined,
      bankIndex: undefined,
      //开户行索引
      columnsFieldNames: {}
    };
  },
  computed: {
    ...mapGetters('account', ['user'])
  },
  /* created() {
    this.initCustomerAccountForm()
  }, */
  mounted() {
    this.initResCodeType(this.codeResItems).then(() => {
      this.initDetail();
    });
  },
  unmounted() {
    this.detail = undefined;
  },
  methods: {
    initDetail() {
      let customerId = this.$route.params && this.$route.params.customerId;
      if (customerId) {
        rqtGetCustomer(customerId, this.user.agentId).then(res => {
          const resData = res.data.data;
          this.form.levelType = resData.customer.levelType;
          if (this.form.levelType == '01') {
            //修改客户时候，签单客户五要素信息不允许修改
            this.isDisabled = true;
          } else {
            this.isDisabled = false;
          }
          this.detail = resData;
          const customer = resData.customer;
          const customerExt = resData.customerExt;
          const customerContact = resData.customerContact;
          const customerAddresses = resData.customerAddresses;
          // const customerAccounts = resData.customerAccounts
          this.form.bankInfo = resData.customerAccounts;
          this.form.id = customer.id;
          this.form.chnName = customer.chnName;
          if (customerExt && customerExt.customerType) {
            if (customerExt.customerType) {
              this.initFitemTextValue('customerType', customerExt.customerType);
            }
            if (customerExt.importType) {
              this.initFitemTextValue('importType', customerExt.importType);
            }
            if (customerExt.buildingId) {
              this.initFitemBuildingId('buildingId', customerExt.buildingId);
            }
            if (customerExt.buildingNo) {
              this.form.buildingNo = customerExt.buildingNo;
            }
          }
          if (customer.categoryType) {
            this.initFitemTextValue('categoryType', customer.categoryType);
          }
          if (customer.obtainWay) {
            this.initFitemTextValue('obtainWay', customer.obtainWay);
          }
          if (customer.idType) {
            this.initFitemTextValue('idType', customer.idType);
          }
          this.form.idNo = customer.idNo;
          this.form.idEndDate = customer.idEndDate;
          if (customer.sex) {
            this.initFitemTextValue('sex', customer.sex);
          }
          this.form.birthday = customer.birthday;
          this.form.mobile = customerContact.mobile;
          this.form.email = customerContact.email;
          this.initCustomerAccountForm();
          this.initFitemAddrs('addrs', customerAddresses);
        }).catch(() => {});
      }
    },
    initFitemTextValue(fItemIndex, value) {
      let fItem = this.form[fItemIndex];
      fItem.value = value;
      fItem.text = this.formatSelectColumn(this.codeResItems, fItemIndex, {
        [fItemIndex]: value
      });
    },
    initFitemBuildingId(fItemIndex, value) {
      const buildingRes = this.codeResItems.find(e => e.dataIndex === fItemIndex);
      value && resTol.initReqResCb(buildingRes.dataRes, rqtGetBuilding, {
        id: value
      }, res => {
        buildingRes.dataRes = res;
        const findItem = buildingRes.dataRes.find(e => e.id === value);
        this.form[fItemIndex].text = findItem.buildingName;
        this.form[fItemIndex].value = value;
      });
    },
    async initFitemAddrs(fItemIndex, value) {
      if (value) {
        let temp = [];
        for (const addr of value) {
          let item = JSON.parse(JSON.stringify(this.addrItemTpl));
          item.id = addr.id;
          item.addressType.value = addr.addressType;
          item.addressType.text = this.formatSelectColumn(this.codeResItems, 'addressType', {
            addressType: addr.addressType
          });
          item.province = addr.province;
          item.city = addr.city;
          item.country = addr.country;
          await Promise.all([rqtGetPlace({
            placeType: '01',
            placeCode: addr.province
          }), rqtGetPlace({
            placeType: '02',
            placeCode: addr.city
          }), rqtGetPlace({
            placeType: '03',
            placeCode: addr.country
          })]).then(([res1, res2, res3]) => {
            const resData1 = res1.data.data;
            const resData2 = res2.data.data;
            const resData3 = res3.data.data;
            item.pcc = [resData1.placeName, resData2.placeName, resData3.placeName].join('/');
          }).catch(() => {});
          item.street = addr.street;
          temp.push(item);
        }
        this.form[fItemIndex] = temp;
      }
    },
    initCustomerAccountForm() {
      let that = this;
      const selectFitems = this.bankResItems.filter(e => e.dataType === "select" && !e.dataRes);
      for (const item of selectFitems) {
        switch (item.dataIndex) {
          case "bankId":
            resTol.initReqResCb(item.dataRes, rqtGetBank, null, res => {
              item.dataRes = res;
              res.find(item => {
                that.form.bankInfo.forEach((curr, index) => {
                  if (item.bankId == curr.bankId) {
                    that.form.bankInfo[index].bankName = item.bankName;
                  }
                });
              });
            });
            break;
        }
      }
    },
    onPickerSelectClick(dataIndex, type, tag) {
      this.fItemDataIndex = dataIndex;
      this.$refs['CodeDataPickerCpt'].showView(type || dataIndex);
      if (tag) {
        this.fItemDataIndex = tag;
      }
    },
    onPickerSelected(selectedValues, selectedOptions) {
      const index = /\[(.+?)\]/g.exec(this.fItemDataIndex);
      if (index) {
        let addressType = this.form.addrs[index[1]].addressType;
        addressType.text = selectedOptions[0].codeName;
        addressType.value = selectedValues[0];
      } else {
        let code = this.form[this.fItemDataIndex];
        code.text = selectedOptions[0].codeName;
        code.value = selectedValues[0];
      }
    },
    onPickerDataSelectClick(dataIndex) {
      this.fItemDataIndex = dataIndex;
      this.columnsFieldNames = {
        text: 'buildingName',
        value: 'id'
      };
      this.$refs['DataPickerCpt'].showView('buildingName', rqtGetBuilding);
    },
    //查询银行
    onpickerDataSelectClickBank(dataIndex, index) {
      this.fItemDataIndex = dataIndex;
      this.bankIndex = index;
      this.columnsFieldNames = {
        text: 'bankName',
        value: 'bankId'
      };
      this.$refs['DataPickerCpt'].showView('bankName', rqtGetBank);
    },
    onPickerDataSelected(selectedValues, selectedOptions) {
      let index = this.bankIndex;
      if (this.fItemDataIndex == 'buildingId') {
        let buildingId = this.form[this.fItemDataIndex];
        buildingId.text = selectedOptions[0].buildingName;
        buildingId.value = selectedValues[0];
      }
      if (this.fItemDataIndex == 'bankId') {
        this.form[this.fItemDataIndex].text = selectedOptions[0].bankName;
        this.form.bankInfo[index].bankId = selectedValues[0];
        this.form.bankInfo[index].bankName = selectedOptions[0].bankName;
      }
    },
    onPickerAddrDataSelectClick(dataIndex) {
      this.fItemDataIndex = dataIndex;
      this.$refs['AddrDataPickerCpt'].showView();
    },
    onPickerAddrDataSelected(val) {
      const index = /\[(.+?)\]/g.exec(this.fItemDataIndex);
      if (index) {
        let addr = this.form.addrs[index[1]];
        addr.pcc = val.map(e => e.placeName).join('/');
        addr.province = val[0] && val[0].placeCode;
        addr.city = val[1] && val[1].placeCode;
        addr.country = val[2] && val[2].placeCode;
      }
    },
    onPopupDateTimeSelectClick(dataIndex) {
      this.fItemDataIndex = dataIndex;
      this.$refs['PopupDateTimeCpt'].showView();
    },
    onDateTimeSelectedChange(val) {
      this.form[this.fItemDataIndex] = val;
    },
    getRightIcon(fieldName) {
      if (this.isDisabled) {
        return '';
      }
      if (typeof this.form[fieldName] == 'object') {
        return !this.form[fieldName].text ? '' : 'close';
      }
      return !this.form[fieldName] ? '' : 'close';
    },
    onRightIconClick(fieldName) {
      if (typeof this.form[fieldName] == 'object') {
        this.form[fieldName].value = undefined;
        this.form[fieldName].text = undefined;
      } else {
        this.form[fieldName] = undefined;
      }
    },
    //添加地址信息
    onAddAddrItem() {
      this.isReadonly = false;
      const newAddr = JSON.parse(JSON.stringify(this.addrItemTpl));
      this.form.addrs.push(newAddr);
    },
    delAddr(index) {
      this.form.addrs.splice(index, 1);
    },
    //添加银行账户信息
    onAddBankItem() {
      const newBank = JSON.parse(JSON.stringify(this.bankItemTpl));
      this.form.bankInfo.push(newBank);
    },
    delBankAcc(index) {
      this.form.bankInfo.splice(index, 1);
    },
    onSubmit() {
      this.btnLoading = true;
      const form = JSON.parse(JSON.stringify(this.form));
      for (const key in form) {
        if (key === 'addrs') {
          form[key].forEach(element => {
            if (this.isTextValueFitem(element, 'addressType')) {
              element.addressType = element.addressType.value;
            } else if (this.hasTextValueFitem(element, 'addressType')) {
              element.addressType = undefined;
            }
          });
        } else {
          if (this.isTextValueFitem(form, key)) {
            form[key] = form[key].value;
          } else if (this.hasTextValueFitem(form, key)) {
            form[key] = undefined;
          }
        }
      }
      const customer = {
        chnName: form.chnName,
        categoryType: form.categoryType,
        obtainWay: form.obtainWay,
        idType: form.idType,
        idNo: form.idNo,
        idEndDate: form.idEndDate,
        sex: form.sex,
        birthday: form.birthday,
        levelType: form.levelType
      };
      customer.agentId = this.user.agentId;
      const customerExt = {
        agentId: this.user.agentId,
        customerType: form.customerType,
        importType: form.importType,
        buildingId: form.buildingId,
        buildingNo: form.buildingNo
      };
      const customerContact = {
        agentId: this.user.agentId,
        mobile: form.mobile,
        email: form.email
      };
      const customerAddresses = form.addrs && form.addrs.length ? form.addrs : undefined;
      const customerAccounts = this.form.bankInfo;
      if (customerAddresses) {
        for (const addr of customerAddresses) {
          addr.agentId = this.user.agentId;
        }
      }
      if (customerAccounts) {
        for (const acc of customerAccounts) {
          acc.agentId = this.user.agentId;
        }
      }
      if (this.detail) {
        customer.id = this.detail.customer.id;
        if (this.detail.customerExt) {
          customerExt.id = this.detail.customerExt.id;
        }
        customerExt.customerId = customer.id;
        customerContact.id = this.detail.customerContact.id;
        customerContact.customerId = customer.id;
        if (customerAddresses) {
          customerAddresses.forEach(e => e.customerId = customer.id);
        }
        if (customerAccounts) {
          customerAccounts.forEach(e => {
            e.customerId = customer.id;
          });
        }
      }
      rqtPostSaveallwms({
        customer,
        customerAddresses,
        customerExt,
        customerContact,
        customerAccounts
      }).then(() => {
        this.btnLoading = false;
        this.$message.success('操作成功');
        this.$router.go(-1);
      }).catch(() => {
        this.btnLoading = false;
      });
    },
    onToVisitRecord() {
      this.$router.push(`/work-wx/customer/visitor/record/${this.detail.customer.id}`);
    },
    onToInvestRecord() {
      this.$router.push(`/work-wx/customer/invest/record/${this.detail.customer.id}`);
    },
    isTextValueFitem(form, key) {
      return form[key] && typeof form[key] === 'object' && form[key].value && 'text' in form[key] && 'value' in form[key];
    },
    hasTextValueFitem(form, key) {
      return form[key] && typeof form[key] === 'object';
    },
    onSaveClick() {
      this.$refs.form.submit();
    }
  }
};